import { LabelText } from 'shared/ui/label';
import { Container } from '../styles';
import { BookingSlotsList } from './BookingSlotsList';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import {
	selectBookingSlotsError,
	selectBookingSlotsLoader,
	useTimeslotZone,
} from 'entities/toolbar/timeslots';
import { useEffect, useState } from 'react';
import { selectOrderDetail, useOrderState } from 'entities/orders';
import { getResourcesFree } from 'entities/hallmap';
import { differenceInMinutes } from 'date-fns';

export const BookingSlots = () => {
  
	const isLoading = useAppSelector(selectBookingSlotsLoader);
	const error = useAppSelector(selectBookingSlotsError);
	const dispatch = useAppDispatch();

	const orderDetail = useAppSelector(selectOrderDetail);
	const { isVisitProgress } = useOrderState(orderDetail);

	const [labelText, setLabelText] = useState('Доступные слоты');
	const { formatISODateBySlotZone } = useTimeslotZone();

	const changeSlotsLabelTextHandler = (text: string) => {
		setLabelText(text);
	};

	useEffect(() => {
		if (isLoading) {
			setLabelText('Доступные слоты');
		}
	}, [isLoading]);

	useEffect(() => {
		if (isVisitProgress && orderDetail) {
			const currentDate = formatISODateBySlotZone(new Date());
			dispatch(
				getResourcesFree({
					dt_requested_start: currentDate,
					duration: differenceInMinutes(
						orderDetail.appointment.dt_end,
						currentDate,
					),
					exclude_appointment: orderDetail?.appointment?.id || undefined
				}),
			);
		}
		//eslint-disable-next-line
	}, []);

	if (isVisitProgress) {
		return null;
	}

	return (
		<Container>
			<LabelText>{labelText}</LabelText>
			<BookingSlotsList
				changeSlotsLabelText={changeSlotsLabelTextHandler}
				isLoading={isLoading}
				error={error}
			/>
		</Container>
	);
};
